import { useDispatch } from 'react-redux'
import { addToast } from '../store/slices/uiSlice'

export function useToast() {
  const dispatch = useDispatch()

  const showToast = (message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info') => {
    dispatch(addToast({ message, type }))
  }

  return { showToast }
}
